/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { YoutubeComponentDisplay } from "cms/components/components/youtube/display";
import { YoutubeComponentEditor } from "cms/components/components/youtube/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

function YoutubeComponent (props) {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <YoutubeComponentDisplay />,
        editComponent: <YoutubeComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
}

YoutubeComponent.displayName = "YoutubeComponent";
export { YoutubeComponent };
